import {
  SPI,
  FormFieldWidget,
  ViewType,
  ModelFieldType,
  Widget,
  BaseFieldOptions,
  deepClone,
  filterRsql,
  ConditionBuilder,
  SearchM2OSelectFieldWidget
} from '@kunlun/dependencies';
import { isNil } from 'lodash-es';

@SPI.ClassFactory(
    FormFieldWidget.Token({
      viewType: [ViewType.Search],
      ttype: ModelFieldType.ManyToOne,
      widget: 'Select'
    })
  )
export class EnterSearchM2OMultiSelectWidget extends SearchM2OSelectFieldWidget {
  public initialize(props) {
    super.initialize(props);
    return this;
  }
  @Widget.Method()
  protected async search(searchValue: string, forceSearch = false) {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    if (!forceSearch) {
      if (this.searchValue === searchValue) {
        return;
      }
    }
    this.searchValue = searchValue;
    if (typeof this.searchValue === 'string') {
      this.searchValue = this.searchValue.trim()
    }
    this.currentPage = 1;
    this.timeout = setTimeout(delaySearch, 400);

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;

    async function delaySearch() {
      const iQueryPageResult = await self.loadOptions({
        condition: builderSelectSearchCondition(self.queryFieldName, self.searchValue, self.domain),
        currentPage: self.currentPage
      });
      if (iQueryPageResult) {
        self.totalPages = getRealPages(iQueryPageResult.totalPages);
        await self.fillOptions(iQueryPageResult.content, false);
      }
    }
  }
}
function getRealPages(val) {
  return isNil(val) ? 1000 : val;
}
const conditionBuilder = ConditionBuilder.getInstance();
const builderSelectSearchCondition = (searchFieldName: string, searchValue: string, domain?: string): string => {
  const realSearchValue = deepClone(filterRsql(searchValue));
  const searchStr = !realSearchValue
    ? '1==1'
    : searchFieldName
        .split(',')
        .map((item) => {
          const condition = conditionBuilder.condition(item).like(`%${realSearchValue}%`);
          return condition.toString();
        })
        .join(' or ');
  const condition = domain
    ? conditionBuilder.condition(searchStr).and(conditionBuilder.condition(domain)).toString()
    : searchStr;
  return condition;
};
